import React, { useEffect, useState } from 'react';
import { usePermitRequestContext } from '../../../../contexts/PermitRequestContext';
import { useProjectConfigContext } from '../../../../contexts/ProjectConfigContext';
import OwnershipCarType from '../../../../types/ownershipCar.type';
import SectionTitle from '../SectionTitle';
import FormSection from './FormSection';
import InputGroup from '../../../../components/form/InputGroup';
import RadioBtnsContainer from '../../../../components/form/radios/RadioBtnsContainer';
import RadioOutlineBtn from '../../../../components/form/radios/RadioOutlineBtn';
import SelectCarColor from '../../../../components/form/selects/SelectCarColor';
import SelectCarMaker from '../../../../components/form/selects/SelectCarMaker';
import SelectVehicleGroup from '../../../../components/form/selects/SelectVehicleGroup';
import addRequestPageLang from '../../../../data/lang/add-request-page.lang';
import { useTags } from '../../../../hooks/useTags';
import formErrorsLang from '../../../../data/lang/form-errors.lang';


function CarDetailsFormSection() {


    const { handleChange, Formik, handleChangeFile } = usePermitRequestContext();
    const { projectConfigState } = useProjectConfigContext();

    const addRequrstPageConfig = projectConfigState.addRequestPageConfig;
    const colorAndType = addRequrstPageConfig.colorAndType;

    const { errors, values, touched, handleBlur, setFieldValue, setFieldTouched } = Formik;
    const [radioBtnState, setChecked] = useState([true, false]);

    const carDetails = values.carDetails;
    const carDetailsErrors = errors.carDetails ? errors.carDetails : {};
    const carDetailsTouched = touched.carDetails ? touched.carDetails : {};

    const generateTag = useTags();
  
    // Define variables for Hebrew tags
    const sectionTitle = generateTag(addRequestPageLang, 'form.car-details-section.title');
    const carIdLabel = generateTag(addRequestPageLang, 'form.car-details-section.carIdLabel');
    const ownershipCarLabel = generateTag(addRequestPageLang, 'form.car-details-section.ownershipCarLabel');
    const privateCarLabel = generateTag(addRequestPageLang, 'form.car-details-section.privateCarLabel');
    const companyCarLabel = generateTag(addRequestPageLang, 'form.car-details-section.companyCarLabel');
    const scanCarIdLabel = generateTag(addRequestPageLang, 'form.car-details-section.scanCarIdLabel');
    const scanWorkStatementLabel = generateTag(addRequestPageLang, 'form.car-details-section.scanWorkStatementLabel');

    const carNumberTouched = carDetailsTouched.carId;
    const carNumberError = carDetailsErrors.carId;
    const carNumberMsg = generateTag(formErrorsLang, carNumberError && carNumberTouched ? carNumberError : '');

    const scanCarIdTouched = carDetailsTouched.scanCarId;
    const scanCarIdError = carDetailsErrors.scanCarId;
    // @ts-ignore
    const scanCarIdMsg = generateTag(formErrorsLang, scanCarIdError && scanCarIdTouched ? scanCarIdError : '');

    const scanWorkStatementTouched = carDetailsTouched.scanWorkStatment;
    const scanWorkStatementError = carDetailsErrors.scanWorkStatment;
    // @ts-ignore
    const scanWorkStatementMsg = generateTag(formErrorsLang, scanWorkStatementError && scanWorkStatementTouched ? scanWorkStatementError : '');

    const vColorTouched = carDetailsTouched.vColor;
    const vColorError = carDetailsErrors.vColor;
    const vColorMsg = generateTag(formErrorsLang, vColorError && vColorTouched ? vColorError : '');

    const vTypeTouched = carDetailsTouched.vType;
    const vTypeError = carDetailsErrors.vType;
    const vTypeMsg = generateTag(formErrorsLang, vTypeError && vTypeTouched ? vTypeError : '');

    const vehicleGroupTouched = carDetailsTouched.vehicleGroup;
    const vehicleGroupError = carDetailsErrors.vehicleGroup;
    const vehicleGroupMsg = generateTag(formErrorsLang, vehicleGroupError && vehicleGroupTouched ? vehicleGroupError : '');


    let inputWorkStatment: string | React.ReactNode = '';

    useEffect(() => {

        setChecked([carDetails.ownershipCarType === OwnershipCarType.PRIVATE ? true : false, carDetails.ownershipCarType === OwnershipCarType.COMPANY ? true : false]);
    }, [carDetails.ownershipCarType]);

    if (carDetails.ownershipCarType === OwnershipCarType.COMPANY) {

        inputWorkStatment = (
            <div className='col-md-6 col-lg-4'>
                <InputGroup
                    type={'file'}
                    name={'carDetails.scanWorkStatment'}
                    label={scanWorkStatementLabel}
                    handleBlur={handleBlur}
                    handleChange={(event) => {
                        handleChangeFile('carDetails.scanWorkStatment', 'scanWorkStatment', event.currentTarget.files[0]);
                    }}
                    isRequired={true}
                    errorMsg={scanWorkStatementMsg}
                />
            </div>
        );
    }

    return (
        <FormSection>
            <SectionTitle title={sectionTitle} />
            <div className='row mb-1'>
                <div className='col-md-6 col-lg-4'>
                    <InputGroup
                        name={'carDetails.carId'}
                        label={carIdLabel}
                        type='number'
                        value={carDetails.carId}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        isRequired={true}
                        errorMsg={carNumberMsg}
                    />
                </div>
                <div className='col-md-6 col-lg-4'>
                    <RadioBtnsContainer label={ownershipCarLabel}>
                        <RadioOutlineBtn
                            isChecked={radioBtnState[0]}
                            label={privateCarLabel}
                            value={OwnershipCarType.PRIVATE}
                            onClick={handleClick}
                            id="ownershipCarTypeYes"
                            name='carDetails.ownershipCarType'
                        />
                        <RadioOutlineBtn
                            isChecked={radioBtnState[1]}
                            label={companyCarLabel}
                            value={OwnershipCarType.COMPANY}
                            onClick={handleClick}
                            id="ownershipCarTypeNo"
                            name='carDetails.ownershipCarType'
                        />
                    </RadioBtnsContainer>
                </div>

            </div>
            <div className='row mb-1'>
                <div className='col-12 col-md-6 col-lg-4'>
                    <InputGroup
                        type={'file'}
                        name={'carDetails.scanCarId'}
                        label={scanCarIdLabel}
                        handleBlur={handleBlur}
                        handleChange={(event) => {
                            handleChangeFile('carDetails.scanCarId', 'scanCarId', event.currentTarget.files[0]);
                        }}
                        isRequired={true}
                        errorMsg={scanCarIdMsg}
                    />
                </div>
                {inputWorkStatment}
            </div>
            {colorAndType ? (

                <div className='row'>
                    <div className='col-md-6 col-lg-3'>
                        <SelectCarColor
                            name={'carDetails.vColor'}
                            value={carDetails.vColor}
                            onChange={(name, newValue) => setFieldValue('carDetails.vColor', newValue)}
                            onBlur={e => {
                                handleBlur(e);
                                setFieldTouched('carDetails.vColor', true);
                            }}
                            errorMsg={vColorMsg}
                        />
                    </div>
                    <div className='col-md-6 col-lg-3'>
                        <SelectCarMaker
                            name={'carDetails.vType'}
                            value={carDetails.vType}
                            onChange={(name, newValue) => setFieldValue('carDetails.vType', newValue)}
                            onBlur={e => {
                                handleBlur(e);
                                setFieldTouched('carDetails.vType', true);
                            }}
                            errorMsg={vTypeMsg}
                        />
                    </div>
                    <div className='col-md-6 col-lg-3'>
                        <SelectVehicleGroup
                            name={'carDetails.vehicleGroup'}
                            value={carDetails.vehicleGroup}
                            required={true}
                            onChange={(name, newValue) => setFieldValue('carDetails.vehicleGroup', newValue)}
                            onBlur={e => {
                                handleBlur(e);
                                setFieldTouched('carDetails.vehicleGroup', true);
                            }}

                            errorMsg={vehicleGroupMsg}
                        />
                    </div>
                </div>
            ) : ''}
        </FormSection>
    );

    function handleClick(e: React.MouseEvent<HTMLInputElement, MouseEvent>) {
        setFieldValue('carDetails.ownershipCarType', Number(e.currentTarget.value));
    }
}

export default CarDetailsFormSection;